import React, { useRef, useEffect, useState } from 'react';
import MainHeaderStandart from '../../../Components/Headers/MainHeader/mainHeader';
import { IMyBusinessProps } from '../../../../../../Pages/My_Business/myBusiness-hooks';
import useMainPageHooks from './main-hooks';
import styles from './main.module.scss';
import { MyBusinessContentItems } from '../../../../../../Interfaces/componentTypes';
import CustomDialog from '../../../../../../Components/Dialog/customDialog';

const Main: React.FC<IMyBusinessProps> = (props) => {
  const { data, onCompanyUpdate } = props;
  const {
    open,
    navRef,
    navHeight,
    largeScreen,
    navItemRefs,
    PAGE_CONTENTS,
    activeContent,
    newOrdersCount,
    dialogComponent,
    BUSINESS_PAGE_NAVS,
    onCloseDialog,
    handleNavClick,
  } = useMainPageHooks(props!);
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [contentHeight, setContentHeight] = useState('80vh');

  useEffect(() => {
    if (headerRef.current) {
      const headerHeight = headerRef.current.offsetHeight;
      setContentHeight(`calc(100vh - ${headerHeight}px)`);
    }
  }, []);

  return (
    <div className={styles.page}>
      <div ref={headerRef}>
        <MainHeaderStandart
          data={data}
          onCompanyUpdate={onCompanyUpdate}
        />
      </div>
      <div
        className={styles.pageContent}
        style={{ minHeight: contentHeight }}
      >
        <div className={styles.container}>
          {largeScreen ? (
            <div className={styles.navBar}>
              <div className={styles.navBox}>
                {BUSINESS_PAGE_NAVS.map((item, index) => (
                  <div
                    key={index}
                    className={activeContent === item.id ? styles.navItemChecked : styles.navItem}
                    onClick={() => handleNavClick(index, item.id)}
                    ref={(el) => (navItemRefs.current[index] = el)}
                    style={{ position: 'relative' }}
                  >
                    <img src={item.icon} alt={`${item.icon}.svg`} />
                    <p>{item.title}</p>
                    {item.id === MyBusinessContentItems.ORDERS && newOrdersCount > 0 && (
                      <span className={styles.notificationBadge}>
                        {newOrdersCount > 99 ? '99+' : newOrdersCount}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div ref={navRef} className={styles.navBarMobile}>
              {BUSINESS_PAGE_NAVS.map((item, index) => (
                <div
                  key={index}
                  className={activeContent === item.id ? styles.navItemChecked : styles.navItem}
                  onClick={() => handleNavClick(index, item.id)}
                  ref={(el) => (navItemRefs.current[index] = el)}
                  style={{
                    position: 'relative',
                    marginRight: item.id === MyBusinessContentItems.ORDERS ? '10px' : undefined,
                  }}
                >
                  <img src={item.icon} alt={`${item.icon}.svg`} />
                  <p>{item.title}</p>
                  {item.id === MyBusinessContentItems.ORDERS && newOrdersCount > 0 && (
                    <span className={styles.notificationBadgeMobile}>
                      {newOrdersCount > 99 ? '99+' : newOrdersCount}
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}

          <div
            className={styles.contentBox}
            style={{ marginTop: !largeScreen ? `${navHeight + 36}px` : '40px' }}
          >
            {PAGE_CONTENTS[activeContent]}
          </div>
        </div>
      </div>
      <CustomDialog
        open={open}
        onClose={onCloseDialog}
        children={dialogComponent}
      />
    </div>
  );
};

export default Main;
